import { html, TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { store } from '@src/store';
import { TOGGLE_MERGE_ACCEPTED } from '@src/store/consents';
import { MergeAccountsDetails } from '@src/types/common';

export const mergeAccountsWrapper = (mergeDetails: MergeAccountsDetails, innerHTML: TemplateResult[], granted = false) => html`
  <div>
    <p data-testid="merge-account-wrapper">
      <strong>
        ${unsafeHTML(mergeDetails.headerText)}
      </strong>
    </p>
    <div class="form-row form-row--group">
        ${innerHTML}
    </div>
    <div class="form-group-checkbox form-group-checkbox--size-small">
      <input
        id="mergeCheckbox"
        name="mergeCheckbox"
        type="checkbox"
        .checked=${granted}
        @change=${() => store.dispatch({ type: TOGGLE_MERGE_ACCEPTED })}
      >
      <label for="mergeCheckbox">
        <strong>
            ${unsafeHTML(mergeDetails.checkboxText)}
        </strong>
      </label>
    </div>
  </div>`;
